import gql from 'graphql-tag';

export const MUTATION = gql`
  mutation removeFundingSource($id: ID!) {
    removeFundingSource(id: $id)
  }
`;
